import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController.ts'
import {getHomepageUrlWithParameter, navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'
import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils.ts'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIWLeaderboardCTAController {
    constructor() {
        const playButtonBaseGame = document.getElementById('leaderboard_play_base_game') as HTMLLinkElement
        const playButton1v1 = document.getElementById('leaderboard_play_1v1') as HTMLLinkElement
        const playButtonCK = document.getElementById('leaderboard_play_c&k') as HTMLLinkElement

        playButtonBaseGame.style.display = 'flex'
        playButton1v1.style.display = 'flex'
        playButtonCK.style.display = 'flex'

        setElementOnClick(playButtonBaseGame, () => {
            AudioManager.play(AudioType.Click)
            this.actionBaseGame()
        })

        setElementOnClick(playButton1v1, () => {
            AudioManager.play(AudioType.Click)
            this.action1v1()
        })

        setElementOnClick(playButtonCK, () => {
            AudioManager.play(AudioType.Click)
            this.actionCK()
        })
    }

    // eslint-disable-next-line class-methods-use-this
    protected actionBaseGame() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, MatchmakingMatchTypes.RankedClassic4P))
    }

    // eslint-disable-next-line class-methods-use-this
    protected action1v1() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, MatchmakingMatchTypes.RankedClassic1v1))
    }

    // eslint-disable-next-line class-methods-use-this
    protected actionCK() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, MatchmakingMatchTypes.RankedCitiesAndKnights4P))
    }
}
